<template>
  <div styleName="optChatBox">
    <div styleName="gate" @click="_changeRightSide">
      <Triangle :rotate="!showRightSide ? 270 : 90" borderSideWidth="5" borderBottomWidth="5" styleName="homeRightTriangle" />
    </div>
    <div styleName="chatboxHeader">
      <div styleName="discuss" @click="_switchDiscussStatus">
        <span styleName="title">{{ $t('chatbox') }}
          <span>（{{userCount}}）</span>
        </span>
        <Triangle styleName="triangle" :rotate=" currentTab === 1 ? 0 : 180" />
        <span styleName="line"></span>
      </div>
      <div styleName="notice" @click="_switchNoticeStatus">
        <span styleName="title">{{ $t('announcement') }}</span>
        <Triangle styleName="triangle" :rotate=" currentTab === 2 ? 0 : 180" />
      </div>
    </div>
    <div styleName="chatboxBody">
      <ul styleName="chatboxInner messagers" v-show="currentTab === 1">
        <li styleName="messagersItem" v-if="teacherInfo && teacherInfo.userid" data-role="teacher" :key="teacherInfo.userid">{{ teacherInfo.alias }}</li>
        <li styleName="messagersItem" v-for="(user, index) in sortUserNames" data-role="student" :key="user.userid + index">{{ user.alias }}</li>
      </ul>
      <div styleName="chatboxInner messages" v-show="currentTab === 2 || currentTab === 0">
        <div styleName="noticeborder" v-if="currentTab === 2">
          <textarea maxlength="100" cols="6" :placeholder="$t('typeHere[1]')" :value="noticeVal" @input="_iptNotice" @blur="_blur" @focus="noticeAreaBlur = false" :data-blur="noticeAreaBlur ? 'active' : ''" ref="noticeBox"></textarea>
        </div>
        <div :style="height">
          <div styleName="messageWrapper" ref="wrapper">
            <ul styleName="messageInner" ref="content">
              <li v-for="message in shownMessages" :key="message.msgId" styleName="messageItem">
                <div styleName="title">
                  <span v-if="message.role !== 2" styleName="teacherName">{{$t('teacher')}}_{{message.alias}}</span>
                  <span v-else styleName="studentName">{{message.alias}}</span>
                  <span styleName="sendTime">{{message.timestamp | timestampHandler}}</span>
                </div>
                <div styleName="messageContent">{{message.data}}</div>
                <div styleName="silence" v-if="message.role === 2">
                  <!-- <button styleName="buttonSilence" @click="_silenceStudent(message.userid)">给麦</button> -->
                  <button styleName="buttonSlient" @click="_silenceStudent(message.userid, message.alias)" :data-silence="~silenceList.indexOf(message.userid) ? 'active' : ''">{{ ~silenceList.indexOf(message.userid) ? $t('cancelSilence') : $t('silence[0]') }}</button>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div styleName="inputbox" ref="footerInput">
          <span styleName="sendMessageNotice" v-if="sendMessageNotice">{{ timeToSend }}s之后才可以发消息哦~</span>
          <div styleName="mask" v-if="!allowedChat"></div>
          <textarea styleName="ipt" @keypress.enter.prevent="_sendMessage" :placeholder="$t('typeHere[0]')" v-model.trim="inputMessage"></textarea>
          <button @click="_sendMessage" styleName="sendBtn" :data-send="!allowedChat ? 'notAllow' : ''" :data-status="allowedChat && inputNotEmpty ? 'active' : ''">{{ $t('send') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import Triangle from '@/components/Triangle'
import { signalSdk } from '@/utils/getSDK'
import { formatDuring } from '@/utils/timestampToTime'
import sensorLog from '@/utils/sensorLog'
import * as types from '@/constants'
const NOTICEBOXHEIGHT = 150
const FOOTERINPUTHEIGHT = 72
const DISTANCETOFETCHDATA = 50 // 滚动获取更多时距顶部的距离
const MAXMESSAGECOUNT = 100
const MAXPAGESIZE = 200
let messageId = 0

export default {
  mixins: [CSSModules(styles)],
  data () {
    return {
      // 0 讨论圈显示消息，不显示公告
      // 1 讨论圈显示姓名列表，不显示公告
      // 2 显示公告栏（公告栏和姓名列表同时显示）
      currentTab: 0,
      showOnlyTeacherMessage: false,
      noticeVal: '',
      noticeAreaBlur: false,
      inputMessage: '',
      listTempStore: [],
      sourceMessages: [],
      userCount: 0,
      silence: '',
      userNames: [],
      allowedChat: true,
      intervalToSendMessage: 1,
      showOnlineUserCount: true,
      scrollToBottom: true, // 消息过多、滚动到底部
      sendMessageNotice: false,
      timeToSend: 0,
      sendMessageFlag: true, // 时间间隔控制
      rotate: 90,
      showRightSide: true, // 右侧部分是否收缩
      teacherInfo: null, // 老师相关信息
      timers: []
    }
  },
  created () {
    this.initSDKListen()
  },
  mounted () {
    this.initSending()
  },
  computed: {
    userRole () {
      return this.$store.getters.roomDetail.data.roomRole
    },
    userId () {
      return this.$store.getters.roomDetail.data.userId
    },
    nickname () {
      return this.$store.getters.roomDetail.data.nickname
    },
    myInfo () {
      return {
        alias: this.nickname,
        userid: this.userId,
        role: this.userRole
      }
    },
    silenceList () {
      return this.$store.getters.silentUserIDList
    },
    height () {
      if (this.currentTab === 0) {
        return { height: `calc(100% - ${FOOTERINPUTHEIGHT}px)` }
      } else if (this.currentTab === 2) {
        return { height: `calc(100% - ${FOOTERINPUTHEIGHT}px - ${NOTICEBOXHEIGHT}px)` }
      }
    },
    inputNotEmpty () {
      return this.inputMessage.length > 0
    },
    shownMessages () {
      if (this.showOnlyTeacherMessage) {
        return this.sourceMessages.filter(m => m.role !== 2)
      } else {
        return this.sourceMessages
      }
    },
    sortUserNames () {
      return this.userNames.filter(user => parseInt(user.role) !== 1 && parseInt(user.userid) !== parseInt(this.userId))
    }
  },
  watch: {
    shownMessages () {
      this.$nextTick(() => {
        if (!this.scrollUp && this.scrollToBottom) {
          this.$refs.wrapper.scrollTop = this.$refs.content.clientHeight
        }
      })
    },
    currentTab (val) {
      if (val === 1) {
        // 获取在线用户列表
        this.showUserlist = true
        this.timers.forEach((timer) => {
          clearTimeout(timer)
        })
        this.timers = []
        this.getAllUserList()
      } else {
        this.userNames = []
        this.showUserlist = false
      }
    }
  },
  filters: {
    timestampHandler (time) {
      return formatDuring(time)
    }
  },
  methods: {
    _changeRightSide () {
      this.showRightSide = !this.showRightSide
      this.$emit('changeRightSide', this.showRightSide)
    },
    // 讨论圈状态切换
    _switchDiscussStatus () {
      if (this.currentTab > 0) {
        this.currentTab = 0
      } else {
        this.currentTab = 1
      }
    },
    // 公告栏状态切换
    _switchNoticeStatus () {
      if (this.currentTab !== 2) {
        this.currentTab = 2
      } else {
        this.currentTab = 0
      }
    },
    // 切换讨论圈显示的信息类型：消息、在线人员
    _switchMessageClass (e) {
      if (e.target.dataset.ele === 'button') {
        this.showOnlyTeacherMessage = !this.showOnlyTeacherMessage
      }
    },
    _iptNotice (e) {
      this.noticeVal = e.target.value
    },
    initSDKListen () {
      // 是否显示在线人数
      signalSdk.on('SHOW_ONLINE_USERNUM', () => {
        this.$store.dispatch('switchShowUserNum', true)
      })
      signalSdk.on('HIDE_ONLINE_USERNUM', () => {
        this.$store.dispatch('switchShowUserNum', false)
      })
      signalSdk.on('TEACHER_LEAVE_ROOM', () => {
        this.teacherInfo = null
      })
      signalSdk.on('TEACHER_ENTER_ROOM', (res) => {
        const { alias, userid, role } = res.msg
        this.teacherInfo = {
          alias,
          userid,
          role
        }
      })
      // 初始用户数量
      signalSdk.on('GET_USER_NUMBER', (num) => {
        this._showUserCountSlowly(num)
      })
      // 聊天消息
      signalSdk.on('CHAT_MESSAGE', (msgList) => {
        this.createCommentList(msgList)
      })
      // 公告栏
      // 初始化
      signalSdk.on('INIT_BOARD_MESSAGE', ({ msg }) => {
        this.noticeVal = msg
      })

      // 根据身份不同 初始化相应的是否允许文字聊天
      signalSdk.on('INIT_ALLOW_CHATWITHMESSAGE', (silence) => {
        this.$store.dispatch('switchAllowChatWithMessage', silence !== 'on')
      })

      // 学生端可以发送消息的时间间隔
      signalSdk.on('SET_MESSAGE_INTERVAL', (interval) => {
        this.handleMessageInterval(interval || 1)
      })

      // // 不允许聊天(全体禁言)
      // signalSdk.on('NOT_ALLOW_TALK', () => {
      //   console.log(`【监听到不开放评论区】`)
      //   this.allowedChat = false
      // })
      // signalSdk.on('ALL_TALK', () => {
      //   console.log(`【监听到开放评论区】`)
      //   this.allowedChat = true
      // })

      // signalSdk.on('GET_TEACHER_ONLINE_STATUS', (isTeacherOnline, teacherInfo) => {
      //   if (isTeacherOnline) {
      //     this.teacherInfo = teacherInfo
      //   }
      // })

      // 单个禁言
      // signalSdk.on('CHATBOX_SLIENT', () => {
      //   console.log(`【监听到被禁言】`)
      //   this.silence = 1
      // })
      // signalSdk.on('CANCEL_CHATBOX_SLIENT', () => {
      //   console.log(`【监听到被取消禁言】`)
      //   this.silence = 0
      // })

      // 初始化禁言状态
      signalSdk.on('INIT_SILENCE', (silence) => {
        this.silence = silence
      })
      // 在获取列表之后 实时更新
      signalSdk.on('USER_ENTERROOM', (res) => {
        this.syncNumberAndUsernames(parseInt(res.msg.data))
      })
      signalSdk.on('USER_LEAVEROOM', (res) => {
        this.syncNumberAndUsernames(parseInt(res.msg.data))
      })
    },
    // 初始化发送消息相关逻辑
    initSending () {
      let once = true
      this.sendMessagePerSecond()
      this.$refs.wrapper.addEventListener('scroll', () => {
        // 滚动时取消
        this.scrollToBottom = false
        if (!this.ticking) {
          window.requestAnimationFrame(() => {
            let sTop = this.$refs.wrapper.scrollTop
            let scrollBottom = this.$refs.content.clientHeight - sTop - this.$refs.wrapper.clientHeight
            if (scrollBottom === 0) {
              this.scrollUp = false
            } else {
              this.scrollUp = true
            }
            if (once && sTop < DISTANCETOFETCHDATA) {
              once = false
              this.hOldTotal = this.$refs.content.clientHeight
              this.sourceMessages.unshift(...this.listTempStore.slice(- MAXMESSAGECOUNT - this.sourceMessages.length, -this.sourceMessages.length))
              this.$nextTick(() => {
                let hNowTotal = this.$refs.content.clientHeight
                if (hNowTotal) {
                  // console.log(hNowTotal, hNowTotal + DISTANCETOFETCHDATA - this.hOldTotal)
                  this.$refs.wrapper.scrollTop = hNowTotal + DISTANCETOFETCHDATA - this.hOldTotal
                  this.hOldTotal = hNowTotal
                }
              })
            }
            if (sTop > DISTANCETOFETCHDATA) {
              once = true
            }
            this.ticking = false;
          });
        }
        this.ticking = true;
      })
    },
    sendMessagePerSecond (ms = 1000) {
      this.sendMessageTimer = setInterval(() => {
        let nowLen = this.listTempStore.length
        if (nowLen !== this.oldListLen) {
          this.sourceMessages = this.listTempStore.slice(-MAXMESSAGECOUNT);
          this.oldListLen = nowLen;
        }
      }, ms);
    },
    _silenceStudent (studentID, alias) {
      if (~this.silenceList.indexOf(studentID)) {
        signalSdk.disSilenceAStudent(Number(studentID)).then((data) => {
          // console.log('解禁言成功！')
          this.$store.dispatch('deleteUserFromSilenceList', studentID)
          sensorLog.track("cancel_silence_student", types.SENSORLOG.type.SUCCESSED, studentID)
        }).catch((err) => {
          sensorLog.track("cancel_silence_student", types.SENSORLOG.type.FAILED, err)
        })
      } else {
        let user = {
          userid: studentID,
          alias: alias
        }
        signalSdk.silenceAStudent(user).then((data) => {
          // console.log('禁言成功！')
          this.$store.dispatch('modifySilentUserList', user)
          sensorLog.track("silence_student", types.SENSORLOG.type.SUCCESSED, user)
        }).catch((err) => {
          sensorLog.track("silence_student", types.SENSORLOG.type.FAILED, err)
        })
      }
    },
    _sendMessage () {
      if (this.userRole === 2 && !this.allowedChat) {
        return
      }
      if (!this.inputNotEmpty) {
        return
      }
      signalSdk.sendTextMessage(this.inputMessage).then((res) => {
        if (!this.scrollToBottom) {
          this.scrollUp = false
          this.scrollToBottom = true
        }
        this.inputMessage = ''
      }).catch((err) => {
        this.inputMessage = ''
        sensorLog.track("send_text_message", types.SENSORLOG.type.FAILED, err)
      })
    },
    _blur () {
      this.noticeAreaBlur = true
      if (this.oldNoticeValue === this.noticeVal) {
        return
      }
      let string = this.noticeVal
      // \n会导致信令侧崩溃，前端屏蔽
      string = string.replace(/\r\n/g, '')
      string = string.replace(/\n/g, '');
      signalSdk.sendBroadMessage(string).then((res) => {
        this.oldNoticeValue = this.noticeVal
        sensorLog.track("send_board_message", types.SENSORLOG.type.SUCCESSED, this.noticeVal)
      }).catch((err) => {
        sensorLog.track("send_board_message", types.SENSORLOG.type.FAILED, err)
      })
    },
    createCommentList (msgList) {
      if (msgList.length !== 0) {
        let chatLists = msgList.map(item => {
          item.alias = item.alias && this.handleName(item.alias)
          item.role = Number(item.role)
          item.id = `${item.userid}_${messageId++}`
          item.data = item.data
          item.timestamp = item.timestamp && item.timestamp.split('_')[0]
          return item
        })
        if (!this.scrollUp) {
          this.scrollToBottom = true
          this.listTempStore.push(...chatLists)
          if (!this.sendMessageTimer) {
            this.sendMessagePerSecond()
          }
        } else {
          clearInterval(this.sendMessageTimer)
          this.sendMessageTimer = null
          this.sourceMessages.push(...chatLists)
          this.listTempStore.push(...chatLists)
        }
      }
    },
    handleName (name) {
      return name.split('|')[0]
    },
    handleMessageInterval (num) {
      num = Number(num)
      this.$store.dispatch('changeTimeToSendMessage', num)
    },
    getAllUserList (page = 1, pageSize = MAXPAGESIZE) {
      return signalSdk.getUsernameList(page, pageSize).then((data) => {
        let userlist = null
        if (data.data.userlist.length) {
          userlist = data.data.userlist.map(_ => JSON.parse(_))
          this.userNames = userlist
        }
        this.userCount = parseInt(data.data.usernum)
      })
    },
    _showUserCountSlowly (current) {
      let diff = current - this.userCount
      current = parseInt(current)
      if (Math.abs(diff) < 20) {
        this.userCount = current
      } else {
        let ranNumBasic = parseInt(diff / 5)
        let timer1 = setTimeout(() => {
          this.userCount = this.userCount + ranNumBasic + Math.ceil(Math.random() * 4) * ((Math.random() > 0.5) ? -1 : 1)
        }, 1000)
        let timer2 = setTimeout(() => {
          this.userCount = this.userCount + ranNumBasic
        }, 3500)
        let timer3 = setTimeout(() => {
          this.userCount = this.userCount + ranNumBasic + Math.ceil(Math.random() * 4) * ((Math.random() > 0.5) ? -1 : 1)
        }, 6500)
        let timer4 = setTimeout(() => {
          this.userCount = current
        }, 9000)
        this.timers = [timer1, timer2, timer3, timer4]
      }
    },
    syncNumberAndUsernames (count) {
      if (!this.showUserlist) {
        this._showUserCountSlowly(count)
      } else {
        if (this.userCount < MAXPAGESIZE || count < MAXPAGESIZE) {
          this.getAllUserList()
        } else {
          this._showUserCountSlowly(count)
        }
      }
    }
  },
  components: {
    Triangle
  }
}
</script>

<style module>
.unsetCursor {
  cursor: unset;
}
</style>
